var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Alert',{attrs:{"type":"warning","show-icon":""}},[_vm._v(" A warning prompt "),_c('template',{slot:"desc"},[_vm._v(" Content of prompt. Content of prompt. Content of prompt. ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }